import { render, staticRenderFns } from "./CustomerPicker.vue?vue&type=template&id=22dd61bc&scoped=true"
import script from "./CustomerPicker.vue?vue&type=script&lang=js"
export * from "./CustomerPicker.vue?vue&type=script&lang=js"
import style0 from "./CustomerPicker.vue?vue&type=style&index=0&id=22dd61bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd61bc",
  null
  
)

export default component.exports